import Service from './ServiceSetup';

export default Service;
